import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Form } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useIntl } from 'react-intl';

interface CustomTermInputText {
  name: string;
  label: string;
  placeholder: string;
}

export default function CustomTermInputText({
  name,
  label,
  placeholder,
}: CustomTermInputText) {
  const labelText = useIntl().formatMessage({ id: label });
  const placeholderText = useIntl().formatMessage({ id: placeholder });
  return (
    <Form.Item name={name} label={labelText} className="scroll">
      <TextArea
        rows={12}
        showCount
        maxLength={5000}
        placeholder={placeholderText}
        disabled={
          !hasPermissions([
            Authorities.REGISTER_COMPANY_CUSTOM_TERMS_UPDATE,
            Authorities.REGISTER_COMPANY_CUSTOM_TERMS_CREATE,
            Authorities.REGISTER_COMPANY_CUSTOM_TERMS_DELETE,
          ])
        }
      />
    </Form.Item>
  );
}
